export const PAYMENT_METHOD_MAP = {
  Cash: '到店付款現金',
  StoreCredit: '現場刷卡',
  Credit: '信用卡付款',
  Atm: '線下匯款',
  Deposit: '儲值金付款',
  Installment: '分期付款',
  StoreLinePay: 'LINE Pay',
  Vacc: 'Atm 虛擬帳戶', // 原文拼寫修正為 Vacc
}
